const currencyList = [
  'GBP', 'AUD', 'CAD', 'CHF', 'CNY', 'CZK',
  'EUR', 'HKD', 'JPY', 'NOK', 'NZD', 'PLN',
  'SEK', 'SGD', 'THB', 'USD', 'BRL', 'EGP',
  'IDR', 'KRW', 'MXN', 'MYR', 'PHP', 'SAR',
  'VND', 'CNH', 'INR', 'NGN',
];
const currencyIconMap = currencyList.reduce((acc, cur) => {
  acc[cur] = `${cur}.png`;
  return acc;
}, {});

export const getCurrencyImage = (currency) => {
  return currencyIconMap[currency] || '';
};

export const CURRENCY_DECIMAL_DIGITS = {
  IDR: 0,
  PHP: 2,
  MYR: 2,
  THB: 0,
  VND: 0,
  USD: 2,
  CAD: 2,
  GBP: 2,
  EUR: 2,
  BRL: 2,
  MXN: 2,
  SAR: 2,
  EGP: 0,
  JPY: 0,
  KRW: 0,
  CNY: 2,
  INR: 2,
};

export const isValidCurrencyAmount = (amount, currency) => {
  try {
    const digits = CURRENCY_DECIMAL_DIGITS[currency];
    if (typeof digits !== 'number') { // 不在字典中, 则直接返回 true
      return true;
    }
    const num = +amount; // 空值和0 直接返回 true
    if (!num) {
      return true;
    }
    const decimal = `${num}`.split('.')[1];
    if (decimal && decimal.length > digits) { // 判断小数位数是否合法
      return false;
    }
  } catch (err) {
    //
  }
  return true;
};

// 根据币种格式化金额
export const formatAmountByCurrency = (amount, currency) => {
  try {
    const num = +amount;
    if (!num || !currency) {
      return num;
    }
    const digits = CURRENCY_DECIMAL_DIGITS[currency];
    if (typeof digits !== 'number') { // 不在字典中, 则直接返回 true
      return num;
    }
    if (digits === 0) {
      return Math.floor(num);
    }
    return (num.toFixed(digits));
  } catch (err) {
    //
  }
  return amount;
};
